export const INVENTORY_SETTINGS_STORAGE_KEY_BASE = 'inventory.settings.v1';
export const INVENTORY_CATEGORIES_STORAGE_KEY_BASE = 'inventory.categories.v1';

function getTenantSuffix() {
  if (typeof window === 'undefined') return '';

  const orgId = window.localStorage.getItem('organizationId');
  if (orgId) return `org.${orgId}`;

  const userId = window.localStorage.getItem('userId');
  if (userId) return `user.${userId}`;

  return '';
}

export function getTenantStorageKey(baseKey) {
  const suffix = getTenantSuffix();
  return suffix ? `${baseKey}.${suffix}` : baseKey;
}

export function getInventorySettingsStorageKey() {
  return getTenantStorageKey(INVENTORY_SETTINGS_STORAGE_KEY_BASE);
}

export function getInventoryCategoriesStorageKey() {
  return getTenantStorageKey(INVENTORY_CATEGORIES_STORAGE_KEY_BASE);
}
